import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { Duel } from "model/Game";

type Props = {
  media: {isPc: boolean}
  duels: Duel[]
}
export default function GameRecordTable(props: Props) {
  return (
    <TableContainer>
      <Table size={props.media.isPc ? 'medium' : 'small'}>
        <TableHead>
          <TableRow>
            <TableCell>試合数</TableCell>
            <TableCell>先後</TableCell>
            <TableCell>勝敗</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
            props.duels.map(duel => (
              <TableRow key={duel.game_number}>
                <TableCell>{duel.game_number}</TableCell>
                <TableCell>{duel.is_first ? '先攻' : '後攻'}</TableCell>
                <TableCell>{duel.is_win ? '勝ち' : '負け'}</TableCell>
              </TableRow>
            ))
          }
        </TableBody>
      </Table>
    </TableContainer>
  )
}